import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

/**
 * A set of dependencies required for the entity collection to function properly.
 * By grouping them together, we avoid the need to import them individually.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class InjectableDependencies extends store.InjectableDependencies {
  /** @see {@link router.Router} */
  public readonly router = ngCore.inject(router.Router)
}
